/**
 * 应用初始化状态管理
 */

// 标记是否已经初始化过
let hasInitialized = false

/**
 * 检查应用是否已经初始化
 * @returns 是否已初始化
 */
export function getHasInitialized(): boolean {
  return hasInitialized
}

/**
 * 设置初始化状态
 * @param value 初始化状态
 */
export function setHasInitialized(value: boolean): void {
  hasInitialized = value
}

